import { render, staticRenderFns } from "./KeyTwentyEight.vue?vue&type=template&id=461c8142&scoped=true&"
import script from "./KeyTwentyEight.vue?vue&type=script&lang=js&"
export * from "./KeyTwentyEight.vue?vue&type=script&lang=js&"
import style0 from "./KeyTwentyEight.vue?vue&type=style&index=0&id=461c8142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461c8142",
  null
  
)

export default component.exports